import { render, staticRenderFns } from "./OnceOffer.vue?vue&type=template&id=22a1769e"
import script from "./OnceOffer.vue?vue&type=script&lang=js"
export * from "./OnceOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports